import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/routeRedirect";

// Legacy URL: answered with a real 301 on the server, preserving query and hash.
export const Route = createFileRoute("/products/performancevision-pro")({
  beforeLoad: permanentRedirect("/products/agentic-enterprise-platform"),
});
